export const setBGColor = (row, color = "d9d9d9") => row.fill = {
  type: 'pattern',
  pattern: 'solid',
  fgColor: { argb: color },
};

export const setFont = (row) => row.font = {
  size: 12,
  bold: true,
};

export const setAlignment = (row, v = "middle", h = "center") => row.alignment = { vertical: v, horizontal: h, wrapText: true }

export const setBorder = (row) => row.border = {
  top: { style: 'thin' },
  left: { style: 'thin' },
  bottom: { style: 'thin' },
  right: { style: 'thin' }
}
